"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POPOVER_SPACE_BETWEEN = exports.ALIGNS = exports.POSITIONS = void 0;
// order of POSITIONS or ANCHOR is important, the first possible value will be applied
var POSITIONS = {
  BOTTOM: "bottom",
  TOP: "top"
};
exports.POSITIONS = POSITIONS;
var ALIGNS = {
  START: "start",
  END: "end",
  CENTER: "center"
};
exports.ALIGNS = ALIGNS;
var POPOVER_SPACE_BETWEEN = 4;
exports.POPOVER_SPACE_BETWEEN = POPOVER_SPACE_BETWEEN;